import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import Button from "../../components/Button";
import Loading from "../../components/Loading";

import "./styles.scss";

export default function Dismiss() {
  const history = useHistory();
  const { contactDetails, dismiss } = useSelector(
    ({ user, insurancePolicies, insurances, dismiss }) => ({
      contactDetails: user.contactDetails,
      dismiss
    })
  );

  const [isLoading, setLoading] = useState(true);
  const [requestNumber, setRequestNumber] = useState();

  useEffect(() => {
    const handleLoading = async () => {
      const resolved = await dismiss;
      if (resolved) {
        setRequestNumber(resolved.dismiss.data.requestNumber);
        setLoading(false);
      }
    };
    handleLoading();
  }, []);

  const totalState = useSelector(state => state);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="dismiss-container">
          <div className="dismiss-card-wrapper">
            <div className="dismiss-card-header-badge-outer">
              <div className="dismiss-card-header-badge-middle"></div>
            </div>
            <div className="dismiss-card-header">
              <div className="dismiss-card-header-badge">
                <img src={require("./../../img/baja.png")} alt="" />
              </div>
              <span className="dismiss-card-header-title">
                Estamos gestionando tu baja
              </span>
            </div>
            <div className="dismiss-card-body">
              <div className="dismiss-card-body-content">
                <div className="dismiss-card-item">
                  Tu número de solicitud es <br />
                  <b>{requestNumber}</b>
                </div>
                <div className="dismiss-card-item">
                  La solicitud fue enviada a <br />
                  <b>{contactDetails.email}</b>
                </div>
              </div>
              <Button onClick={() => history.push("/")}>Finalizar</Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
